import React, { useState, useEffect } from "react";
import "./Css/StaffRights.css";
import Header from "./Header";
import Loader from "./Loader.js";
import GreyArrow from "../assets/greyLeftAr.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";
import {
  handleAphabetsChange,
  check_vaild_save,
  combiled_form_data,
  handleSuccessSession,
  handleError,
  handleURLChange,
  empty_form,
  handleIaphabetnumberChange,
  formatDateStringdot,
  handleNumbersChange,
  handleAlphabetsNumberWithoutSpaceChange,
  computeTodayDate,
} from "../CommonJquery/CommonJquery";
import {
  server_post_data,
  add_maintainance_data,
  maintainance_data_dropdown,
  maintainance_data_for_id,
  maintainance_status,
} from "../ServiceConnection/serviceconnection.js";
import { Link, useLocation, useSearchParams } from "react-router-dom";
function MaintenanceDetailsPrice() {
  const location = useLocation();
  const currentUrl = location.pathname.substring(1);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [editorDataMainID, setEditorDatMainID] = useState("0");
  const [MaintainanceData, setMaintainanceData] = useState([]);
  const [maintainanceid, setmaintainanceid] = useState([]);
  const [CarData, setCarData] = useState([]);
  const [CarMaintainance, setCarMaintainance] = useState([]);
  const [type, setType] = useState([]);
  const [addpriceHook, setAddPriceHook] = useState([]);
  const [activeAgree2, setActiveAgree2] = useState(true);
  const [totalPrice, setTotalPrice] = useState(0); // State to hold total price
  const [PaymentMode, setPaymentMode] = useState("Cash");
  const handleSaveChangesdynamic1 = async (form_data) => {
    let vaild_data = check_vaild_save(form_data);
    setshowLoaderAdmin(true);
    if (vaild_data) {
      let fd_from = combiled_form_data(form_data, null);
      // let fd_from = new FormData()
      fd_from.append("flag", 2);
      // fd_from.append("call_id", id)
      const serializedData = addpriceHook
        .map((item) => `${item.id}:${item.price}`)
        .join(",");
      fd_from.append("maintenance_price", serializedData);
      fd_from.append("totalPrice", totalPrice);
      fd_from.append(
        "last_maintenance_date",
        CarMaintainance.next_maintenance_date
      );
      fd_from.append("contract_id", CarMaintainance.contract_id);
      fd_from.append("booking_id", CarMaintainance.primary_id);
      fd_from.append("car_id", CarMaintainance.car_id);
      await server_post_data(add_maintainance_data, fd_from)
        .then((Response) => {
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            master_data_get();
          }
        })
        .catch((error) => {
          setshowLoaderAdmin(false);
          handleError("network");
        });
    } else {
      setshowLoaderAdmin(false);
      handleError("Fill Price field");
    }
  };

  console.log(CarMaintainance.contract_id);

  const handleStatusChangesdynamic = async () => {
    let fd_from = new FormData();
    fd_from.append("call_id", CarMaintainance.primary_id);
    fd_from.append("status", 3);

    await server_post_data(maintainance_status, fd_from)
      .then((Response) => {
        setshowLoaderAdmin(false);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          master_data_get();
        }
      })
      .catch((error) => {
        setshowLoaderAdmin(false);
        handleError("network");
      });
  };
  const handleChange2 = (event) => {
    setPaymentMode(event.target.value);
  };

  const master_data_get = async () => {
    const url = currentUrl;
    const parts = url.split("/");
    let call_id = 0;
    let flag = 1;
    if (parts.length !== 1) {
      call_id = parts[1];
      setmaintainanceid(call_id);
      flag = 2;
    }
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("m_id", call_id);
    await server_post_data(maintainance_data_dropdown, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          
          setCarData(Response.data.message.car_data);
          setCarMaintainance(Response.data.message.booking_data);
          setType(Response.data.message.maintenance_labels);
          if (Response.data.message.booking_data.last_maintenance_id !== "0") {
            master_data_get_again(
              Response.data.message.booking_data.last_maintenance_id,
              1
            );
          }
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        // handleError("network");
        setshowLoaderAdmin(false);
      });
  };
  const master_data_get_again = async (id, flag) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("call_id", id);
    fd.append("flag", flag);
    await server_post_data(maintainance_data_for_id, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setMaintainanceData(Response.data.message.maintainance_data);
          const updatedPriceHook = Response.data.message.maintainance_data.map(
            (item) => ({
              id: item.primary_id,
              price: item.maintenance_price || 0,
            })
          );
          const calculatedTotal = updatedPriceHook.reduce(
            (sum, item) => Number(sum) + Number(item.price),
            0
          );
          setTotalPrice(calculatedTotal);
          setAddPriceHook(updatedPriceHook);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        setshowLoaderAdmin(false);
      });
  };

  useEffect(() => {
    master_data_get();
  }, []);
  // const handlepricemanage = (price, id) => {
  //     setAddPriceHook((prevState) => {
  //         return [
  //             ...prevState.filter((item) => item.id !== id),
  //             { id, price },
  //         ];
  //     });

  // };

  const handlepricemanage = (price, id) => {
    setAddPriceHook((prevState) => {
      const updatedPrices = [
        ...prevState.filter((item) => item.id !== id),
        { id, price: parseFloat(price) || 0 }, // Ensure the price is a number
      ];
      // Calculate the total price
      const newTotalPrice = updatedPrices.reduce(
        (sum, curr) => Number(sum) + Number(curr.price),
        0
      );
      setTotalPrice(newTotalPrice);
      return updatedPrices;
    });
  };

  const handleNumbersChange = (e) => {
    const value = e.target.value;
    if (isNaN(value)) {
      e.target.value = ""; // Reset the input if not a number
    }
  };

  const openCustomDatePicker = (customDatePickerInput_id) => {
    console.log(customDatePickerInput_id);
    document.getElementById(customDatePickerInput_id).focus();
  };
  const [startDate, setStartDate] = useState(null);

  const computeTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // "yyyy-mm-dd" format
  };
  return (
    <div className="dashboard">
      {showLoaderAdmin && <Loader />}
      <div className="dashboard_container">
        <Header />
        <div className="page_content">
          <div className="page_content_container">
            <div className="pageCntn_head" style={{ top: "0px" }}>
              <div className="pageNameDiv">
                <p>
                  <p>Maintenance Details</p>
                </p>
                <img src={GreyArrow} alt="Rapid Car Leasing" />
              </div>
            </div>

            <div className="page_body container">
              <div className="create_staffRights">
                <div className="row m-0">
                  <div className="personalForm">
                    <div className="carinformation ">
                      <div className="row">
                        {/* Blockquote 1 */}
                        <div className="col-md-3 mb-4">
                          <blockquote className="custom-blockquote primary">
                            <p>Car Name</p>
                            <footer>-{CarData.car_name}</footer>
                          </blockquote>
                        </div>
                        {/* Blockquote 2 */}
                        <div className="col-md-3 mb-4">
                          <blockquote className="custom-blockquote success">
                            <p>Car Modal</p>
                            <footer>-{CarData.model_name}</footer>
                          </blockquote>
                        </div>
                        {/* Blockquote 3 */}
                        <div className="col-md-3 mb-4">
                          <blockquote className="custom-blockquote danger">
                            <p>Car Fuel Type</p>
                            <footer>-{CarData.fuel_type}</footer>
                          </blockquote>
                        </div>
                        {/* Blockquote 4 */}
                        <div className="col-md-3 mb-4">
                          <blockquote className="custom-blockquote warning">
                            <p>Car Gear Type</p>
                            <footer>-{CarData.gear_type}</footer>
                          </blockquote>
                        </div>
                      </div>
                    </div>

                    {/*----------car info 2------------ */}
                    <div className="carinformation2 ">
                      <div className="row">
                        {/* Blockquote 1 */}
                        <div className="col-md-3 mb-4">
                          <blockquote className="custom-blockquote primary">
                            <p>Car Number</p>
                            <footer>-{CarData.car_no}</footer>
                          </blockquote>
                        </div>
                        {/* Blockquote 2 */}
                        <div className="col-md-3 mb-4">
                          <blockquote className="custom-blockquote success">
                            <p> Last Maintenance Date</p>
                            <footer>
                              -{CarMaintainance.last_maintenance_date}
                            </footer>
                          </blockquote>
                        </div>
                        {/* Blockquote 3 */}
                        <div className="col-md-3 mb-4">
                          <blockquote className="custom-blockquote danger">
                            <p> Next Maintenance Date</p>
                            <footer>
                              -{CarMaintainance.next_maintenance_date}
                            </footer>
                          </blockquote>
                        </div>
                        {/* Blockquote 4 */}
                        <div className="col-md-3 mb-4">
                          <blockquote className="custom-blockquote warning">
                            <p>Last Maintenance K.M.</p>
                            <footer>
                              -{CarMaintainance.last_maintenance_km}
                            </footer>
                          </blockquote>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {MaintainanceData && MaintainanceData.length > 0 && (
                  <div className="row mt-5 container flex justify-center align-middle">
                    <form className="createRightsForm" id="createRightsForm">
                      <table id="myTable" className="display table">
                        <colgroup>
                          <col style={{ width: "20%" }} />
                          <col style={{ width: "20%" }} />
                          <col style={{ width: "20%" }} />
                          <col style={{ width: "20%" }} />
                          <col style={{ width: "20%" }} />
                        </colgroup>
                        <thead>
                          <tr>
                            <th scope="col" className="th3">
                              S. No.
                            </th>
                            <th scope="col">Entry Date</th>
                            <th scope="col">Maintenance Type</th>
                            <th scope="col">Maintenance Name</th>
                            <th scope="col">Price</th>
                          </tr>
                          <tr style={{ height: "25px" }}></tr>
                        </thead>
                        <tbody>
                          {MaintainanceData &&
                            MaintainanceData.length > 0 &&
                            MaintainanceData.map((item, index) => (
                              <React.Fragment key={index}>
                                <tr>
                                  <td className="th3">
                                    <p>{index + 1}</p>
                                  </td>
                                  <td>
                                    <div className="recentContact">
                                      <p>
                                        {formatDateStringdot(item.entry_date)}
                                      </p>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="recentContact">
                                      <p>{item.maintenance_name}</p>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="recentContact">
                                      <p>{item.maintenance_note}</p>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="flex justify-between">
                                      <input
                                        type="text"
                                        id="maintenance_price"
                                        name="maintenance_price"
                                        className="form-control"
                                        defaultValue={item.maintenance_price}
                                        placeholder="Enter Maintenance price"
                                        onInput={handleNumbersChange}
                                        onChange={(e) =>
                                          handlepricemanage(
                                            e.target.value,
                                            item.primary_id
                                          )
                                        }
                                      />
                                    </div>
                                  </td>
                                </tr>
                                <tr
                                  style={{ height: "1rem", boxShadow: "none" }}
                                ></tr>
                              </React.Fragment>
                            ))}
                        </tbody>
                      </table>
                      <div className="total-price d-flex justify-content-end w-100">
                        <h5 className="marginleftPrice">
                          Total Price: {Number(totalPrice).toFixed(2)}
                        </h5>
                      </div>
                    </form>
                    <div className="row">
                      <div className="col-md-4">
                        {" "}
                        <label className="no_prsnl_id">
                          Next Maintenance Date
                        </label>
                        <div className="date-picker-container">
                          <div className="input-with-icon">
                            <FaCalendarAlt
                              className="calendar-icon"
                              onClick={() =>
                                document
                                  .getElementById("next_maintenance_date")
                                  .click()
                              }
                            />

                            <DatePicker
                              id="next_maintenance_date"
                              name="next_maintenance_date"
                              selected={startDate}
                              onChange={(date) => setStartDate(date)}
                              minDate={new Date(computeTodayDate())}
                              dateFormat="yyyy-MM-dd"
                              placeholderText="DD/MM/YYYY"
                              className={`form-control input_field_custom1 ${
                                activeAgree2 ? "trio_mandatory" : ""
                              }`}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <label className="no_prsnl_id">Amount Pay</label>
                        <input
                          type="text"
                          id="total_advance"
                          name="total_advance"
                          placeholder={"Amount Pay"}
                          minLength={1}
                          maxLength={75}
                          className={`  form-control  input_field_custom1 ${
                            activeAgree2 === true ? "trio_mandatory" : ""
                          }`}
                          onInput={(e) => {
                            handleNumbersChange(e);
                          }}
                        />
                      </div>
                      <div className="col-md-4">
                        {" "}
                        <label className="no_prsnl_id">Payment Mode</label>
                        <select
                          name="payment_mode"
                          id="payment_mode"
                          className={`  form-control  input_field_custom1 ${
                            activeAgree2 === true ? "trio_mandatory" : ""
                          }`}
                          value={PaymentMode}
                          onChange={handleChange2}
                        >
                          <option value="" hidden>
                            Select Payment Mode
                          </option>
                          <option value="Cash">Cash</option>
                          <option value="Online">Online</option>
                          <option value="Card">Card</option>
                        </select>
                      </div>

                      <p
                        style={{
                          display:
                            activeAgree2 === false ||
                            PaymentMode === "Online" ||
                            PaymentMode === "Card"
                              ? "inline"
                              : "none",
                          justifyContent: "space-around",
                        }}
                      >
                        <div className="row">
                          <div className="col-md-6">
                            {" "}
                            <label className="no_prsnl_id">
                              Transaction ID
                            </label>
                            <input
                              type="text"
                              id="transaction_id"
                              name="transaction_id"
                              placeholder={"Transaction Id"}
                              minLength={3}
                              maxLength={75}
                              className={`  form-control  input_field_custom1 ${
                                activeAgree2 === false ||
                                PaymentMode === "Online" ||
                                PaymentMode === "Card"
                                  ? "trio_mandatory"
                                  : ""
                              }`}
                              onInput={(e) => {
                                handleIaphabetnumberChange(e);
                              }}
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="no_prsnl_id">
                              Transaction Note
                            </label>

                            <input
                              type="text"
                              id="transaction_note"
                              name="transaction_note"
                              placeholder={"Transaction Note"}
                              minLength={3}
                              maxLength={75}
                              className={`trio_name  form-control  input_field_custom1 ${
                                activeAgree2 === false ||
                                PaymentMode === "Online" ||
                                PaymentMode === "Card"
                                  ? "trio_mandatory"
                                  : ""
                              }`}
                              onInput={(e) => {
                                handleAphabetsChange(e);
                              }}
                            />
                          </div>
                        </div>
                      </p>
                      <p
                        style={{
                          display:
                            activeAgree2 === false ||
                            PaymentMode === "Online" ||
                            PaymentMode === "Card"
                              ? "inline"
                              : "none",
                          justifyContent: "space-around",
                        }}
                      ></p>

                      <p
                        style={{
                          display: activeAgree2 === false ? "flex" : "none",
                          justifyContent: "space-around",
                        }}
                      >
                        <input
                          type="text"
                          id="reason_for_cancel"
                          name="reason_for_cancel"
                          placeholder={"Reason for cancel"}
                          minLength={3}
                          maxLength={75}
                          className={`trio_name  form-control  input_field_custom1 ${
                            activeAgree2 === false ? "trio_mandatory" : ""
                          }`}
                          onInput={(e) => {
                            handleAphabetsChange(e);
                          }}
                        />
                      </p>
                    </div>

                    <button
                      className="btn btn-primary mt-4 Create_Right_Btn btnSave"
                      type="button"
                      onClick={() =>
                        handleSaveChangesdynamic1("createRightsForm")
                      }
                    >
                      Submit
                    </button>
                  </div>
                )}
              </div>
              {/* <div className="createRightBtnDiv">
                                <button
                                    className="btn btn-primary mt-4 Create_Right_Btn btnSave"
                                    type="button"
                                    onClick={() =>
                                        handleStatusChangesdynamic()
                                    }
                                >
                                    Finalized
                                </button>
                            </div> */}
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MaintenanceDetailsPrice;
